import { Mail, MessageCircle, Phone } from 'lucide-react';

export const WHATSAPP_LINK =
  'https://api.whatsapp.com/send/?phone=34622799796&text=Hi+%2AAlquiler+de+Bicicletas+en+Mallorca+%7C+Tours%2C+El%C3%A9ctricas+y+MTB+-+Monkey%2A%21+I+need+more+info&type=phone_number&app_absent=0';

/** Misma información de contacto que la pantalla de mantenimiento (teléfonos + email). */
export const SUPPORT_CONTACT_ITEMS = [
  { icon: Phone, key: 'footer.contact.phone1', href: 'tel:+34971585838' },
  { icon: MessageCircle, key: 'footer.contact.phone2', href: WHATSAPP_LINK },
  { icon: Mail, key: 'footer.contact.email', href: 'mailto:info@monkeyjetski.com' },
];
